import React, { Component } from 'react';
import { Player } from 'video-react';
import "../../../../node_modules/video-react/dist/video-react.css"; // import css
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import connect from "react-redux/lib/connect/connect";
import * as galleryActions from "../../../actions/gallery";
import {IMGIX_PATH} from "../../../constants";

class VideoItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            imageId: ''

        };

    }

    render() {
        let image = this.props.item;
console.log(this.props.item);
        let videoPath = image.img_path;
        let defImgSrc = require("../../../assets/images/no-image.jpg");

        let img_name_arr = image.img_name.split('.');
        let img_name = '';
        if(img_name_arr.length > 0) {
            for(var i=0; i<img_name_arr.length-1; i++) {
                img_name += img_name_arr[i];
            }
            img_name += '-1.jpg';
        }
        defImgSrc = IMGIX_PATH +'video_tn/'+ img_name+'?fit=crop&h=450&w=560&auto=enhance&dpr=3%203x';

        //defImgSrc = require("../../assets/images/no-video.jpg");



        let elId = this.props.iteration;
        return (

            <div className={ `carousel-item ytplayer-height-adj item ${(parseInt(this.props.galleryInfo.itemIndex) === parseInt(elId) ? "active" : "")}` }  id={"video"+elId}>

                <Player
                    playsInline
                    poster= {defImgSrc}
                    src= {videoPath}
                    width="100%"
                    height={450}
                    fluid = {false}
                />

            </div>
        );
    }


}

VideoItem.propTypes = {
    iteration: PropTypes.number
}
function mapStateToProps(state) {


    return {
        galleryInfo  :state.gallery.galleryUpdate,
        galleryData  :state.gallery.galleryData
    };

}


export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    download : galleryActions.downloadFile
})(VideoItem));




// WEBPACK FOOTER //
// ./src/components/includes/Slider/VideoItem.js